<template>
  <div id="reset-password-form" class="box auth" @keyup.enter="reset()">
    <h1 class="title is-size-3 has-text-centered">
      {{ $t('reset_password_form.title') }}
    </h1>

    <div
      class="message is-small is-danger animated fast fadeIn"
      v-if="errorMessage"
    >
      <div class="message-body">{{ $t(errorMessage) }}</div>
    </div>

    <div
      class="message is-small is-success animated fast fadeIn"
      v-if="hasResetPassword"
    >
      <div class="message-body">
        <p>{{ $t('reset_password_form.success.reset_password') }}</p>
        <p>{{ $t('reset_password_form.success.close') }}</p>
      </div>
    </div>

    <div class="field">
      <label for="email" class="label">{{
        $t('reset_password_form.new_password_label')
      }}</label>
      <div class="control">
        <input
          type="password"
          id="password"
          class="input is-shadowless"
          required
          autofocus
          v-model="password"
        />
      </div>
    </div>

    <div class="field field-action">
      <div class="control">
        <gradient-button
          :title="$t('reset_password_form.reset_password_button')"
          :is-inline="true"
          :is-loading="isLoading"
          @click.native="reset()"
        ></gradient-button>
      </div>
    </div>
  </div>
</template>

<script>
import Http from 'services/Http';
import { GradientButton } from 'components/buttons';

const URL = 'https://identitytoolkit.googleapis.com/v1/accounts:resetPassword';

export default {
  components: {
    GradientButton,
  },

  data() {
    return {
      password: '',
      errorMessage: '',
      isLoading: false,
      hasResetPassword: false,
    };
  },

  methods: {
    isStrongPassword(password) {
      let strengths = 0;

      const uppercase = /[A-Z]/.test(password);
      const lowercase = /[a-z]/.test(password);
      const number = /[0-9]/.test(password);
      const specialChar = /[^a-zA-Z\d\s:]/.test(password);

      if (uppercase) {
        strengths++;
      }
      if (lowercase) {
        strengths++;
      }
      if (number) {
        strengths++;
      }
      if (specialChar) {
        strengths++;
      }

      return password.length >= 10 && strengths > 3;
    },
    reset() {
      if (this.isLoading) {
        return;
      }

      if (this.password === '') {
        this.errorMessage = 'reset_password_form.errors.password_empty_field';
        return;
      }

      if (!this.oobCode) {
        this.errorMessage =
          'reset_password_form.errors.reset_token_empty_field';
        return;
      }

      if (!this.apiKey) {
        this.errorMessage =
          'reset_password_form.errors.reset_api_key_empty_field';
        return;
      }

      if (!this.isStrongPassword(this.password)) {
        this.errorMessage =
          'reset_password_form.errors.password_rules_not_followed';
        return;
      }

      this.isLoading = true;
      this.errorMessage = '';

      Http.post(`${URL}?key=${this.apiKey}`, {
        oobCode: this.oobCode,
        newPassword: this.password,
      })
        .then(() => {
          this.errorMessage = '';
          this.hasResetPassword = true;
        })
        .catch(err => {
          this.errorMessage =
            err.message || 'reset_password_form.errors.reset_password_failed';
          this.hasResetPassword = false;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },

  computed: {
    oobCode() {
      return this.$route.query.oobCode;
    },
    apiKey() {
      return this.$route.query.apiKey;
    },
  },
};
</script>
